import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import {PaginationModel} from '@shared/models/pagination.model';
import {PageKatottgModel} from '@services/back-office/model/pageKatottgModel';
import {KatottgModel} from '@services/back-office/model/katottgModel';
import {KatottgSearchRequest} from '@services/back-office/model/katottgSearchRequest';
import {LocationPointModel} from '@services/back-office/model/locationPointModel';
import {KatottgRequest} from '@services/back-office/model/katottgRequest';

export enum KatottgActionTypes {
  LoadKatottg = '[Katottg] Load Katottg',
  LoadKatottgSuccess = '[Katottg] Load Katottg Success',
  LoadKatottgFailure = '[Katottg] Load Katottg Failure',
  SetKatottgLocation = '[Katottg] Set Katottg location',
  SetKatottgLocationSuccess = '[Katottg] Set Katottg location Success',
  SetKatottgLocationFailure = '[Katottg] Set Katottg location Failure',
  AddKatottgCityRegion = '[Katottg] Add Katottg City Region',
  AddKatottgCityRegionSuccess = '[Katottg] Add Katottg City Region Success',
  AddKatottgCityRegionFailure = '[Katottg] Add Katottg City Region Failure',
  EditKatottgCityRegion = '[Katottg] Edit Katottg City Region',
  EditKatottgCityRegionSuccess = '[Katottg] Edit Katottg City Region Success',
  EditKatottgCityRegionFailure = '[Katottg] Edit Katottg City Region Failure',
  DeleteKatottgCityRegion = '[Katottg] Delete Katottg City Region',
  DeleteKatottgCityRegionSuccess = '[Katottg] Delete Katottg City Region Success',
  DeleteKatottgCityRegionFailure = '[Katottg] Delete Katottg City Region Failure',
  ChangePage = '[Katottg] Change Page',
  SetInitialPagination = '[Katottg] Set Initial Pagination',
  SetFilter = '[Katottg] Set Filter',
  ClearFilter = '[Katottg] Clear Filter',
  SetInitialState = '[Katottg] Set Initial State',
}

/** Load Katottg */
export class LoadKatottg implements Action {
  readonly type = KatottgActionTypes.LoadKatottg;
  constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadKatottgSuccess implements Action {
  readonly type = KatottgActionTypes.LoadKatottgSuccess;
  constructor(public payload: PageKatottgModel) { }
}

export class LoadKatottgFailure implements Action {
  readonly type = KatottgActionTypes.LoadKatottgFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Set Katottg location */
export class SetKatottgLocation implements Action {
  readonly type = KatottgActionTypes.SetKatottgLocation;
  constructor(public payload: {kattottgId: string, polyPoints: LocationPointModel[]}) { }
}

export class SetKatottgLocationSuccess implements Action {
  readonly type = KatottgActionTypes.SetKatottgLocationSuccess;
  constructor(public payload: KatottgModel) { }
}

export class SetKatottgLocationFailure implements Action {
  readonly type = KatottgActionTypes.SetKatottgLocationFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Add Katottg City Region */
export class AddKatottgCityRegion implements Action {
  readonly type = KatottgActionTypes.AddKatottgCityRegion;
  constructor(public payload: KatottgRequest) { }
}

export class AddKatottgCityRegionSuccess implements Action {
  readonly type = KatottgActionTypes.AddKatottgCityRegionSuccess;
  constructor(public payload: KatottgModel) { }
}

export class AddKatottgCityRegionFailure implements Action {
  readonly type = KatottgActionTypes.AddKatottgCityRegionFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Edit Katottg City Region */
export class EditKatottgCityRegion implements Action {
  readonly type = KatottgActionTypes.EditKatottgCityRegion;
  constructor(public payload: {katottgId: string, request: KatottgRequest}) { }
}

export class EditKatottgCityRegionSuccess implements Action {
  readonly type = KatottgActionTypes.EditKatottgCityRegionSuccess;
  constructor(public payload: KatottgModel) { }
}

export class EditKatottgCityRegionFailure implements Action {
  readonly type = KatottgActionTypes.EditKatottgCityRegionFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Delete Katottg City Region */
export class DeleteKatottgCityRegion implements Action {
  readonly type = KatottgActionTypes.DeleteKatottgCityRegion;
  constructor(public payload: string) { }
}

export class DeleteKatottgCityRegionSuccess implements Action {
  readonly type = KatottgActionTypes.DeleteKatottgCityRegionSuccess;
  constructor(public payload: string) { }
}

export class DeleteKatottgCityRegionFailure implements Action {
  readonly type = KatottgActionTypes.DeleteKatottgCityRegionFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Change Page */
export class ChangePage implements Action {
  readonly type = KatottgActionTypes.ChangePage;
  constructor(public payload: PaginationModel) { }
}

/** Set Initial Pagination */
export class SetInitialPagination implements Action {
  readonly type = KatottgActionTypes.SetInitialPagination;
}

/** Set Filter */
export class SetFilter implements Action {
  readonly type = KatottgActionTypes.SetFilter;
  constructor(public payload: KatottgSearchRequest) { }
}

/** Clear Filter */
export class ClearFilter implements Action {
  readonly type = KatottgActionTypes.ClearFilter;
}

/** Set Initial State */
export class SetInitialState implements Action {
  readonly type = KatottgActionTypes.SetInitialState;
}

export type KatottgActions =
  | LoadKatottg
  | LoadKatottgSuccess
  | LoadKatottgFailure
  | SetKatottgLocation
  | SetKatottgLocationSuccess
  | SetKatottgLocationFailure
  | AddKatottgCityRegion
  | AddKatottgCityRegionSuccess
  | AddKatottgCityRegionFailure
  | EditKatottgCityRegion
  | EditKatottgCityRegionSuccess
  | EditKatottgCityRegionFailure
  | DeleteKatottgCityRegion
  | DeleteKatottgCityRegionSuccess
  | DeleteKatottgCityRegionFailure
  | ChangePage
  | SetInitialPagination
  | SetFilter
  | ClearFilter
  | SetInitialState
  ;

